import React from "react";
import {css} from "@emotion/css";
import {useState} from "react";
import ChooseResidenceFromTheList from "./ChooseResidenceFromTheList";
import ShowResidenceInformation from "./ShowResidenceInformation";
import {RaikoGridOneColumn, RaikoStepper} from "@moeindal/base-raiko-panel-components";

const AllocationResidence = ({reserveId, periodId, requestId, handleCloseDialog}) => {


    const [stepCounter, setStepCounter] = useState(0);
    const [residenceInfo, setResidenceInfo] = useState()

    function handleSelectNewResidence(residenceInfo) {
        setResidenceInfo(residenceInfo)
        setStepCounter(allocationResidenceLevel.residenceInformation.activeLevel)
    }


    return (
        <RaikoGridOneColumn
            className={css`
                padding: .5rem 1rem 1rem 1rem;`}>
            <RaikoStepper
                activeStep={stepCounter}
                className={css`margin-bottom: 1rem;`}
                orientation={"horizontal"}
                steps={[
                    allocationResidenceLevel.residenceList.title,
                    allocationResidenceLevel.residenceInformation.title,
                ]}
            />

            {stepCounter === allocationResidenceLevel.residenceList.activeLevel &&
                <ChooseResidenceFromTheList periodId={periodId} selectNewResidence={handleSelectNewResidence}/>
            }
            {stepCounter === allocationResidenceLevel.residenceInformation.activeLevel &&
                <ShowResidenceInformation
                    handleCloseDialog={handleCloseDialog}
                    periodId={periodId}
                    requestId={requestId}
                    reserveId={reserveId}
                    residenceInfo={residenceInfo}
                    handleBackPage={_ => {
                        setStepCounter(allocationResidenceLevel.residenceList.activeLevel)
                    }}/>
            }

        </RaikoGridOneColumn>
    )
}
export default AllocationResidence;
const allocationResidenceLevel = {
    residenceList: {
        activeLevel: 0,
        title: "لیست اقامتگاه ها"
    },
    residenceInformation: {
        activeLevel: 1,
        title: "اطلاعات اقامتگاه"
    },
}